<template>
  <b-overlay
    :show="loading"
    variant="white"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-table
      ref="categories-table"
      hover
      responsive
      :items="categories"
      :fields="fields"
      :no-local-sorting="true"
    >
      <template #cell(name)="data">
        <b-form-input
          v-model="data.item.name"
          @change="handleUpdate(data.item)"
        />
      </template>
      <template #cell(actions)="data">
        <b-link
        >
          <span
            class="d-inline-block px-50 text-danger"
            @click="handleDeleteButtonClick(data.item)"
          >
            <feather-icon
              v-b-tooltip.hover 
              title="Eliminar"
              icon="TrashIcon"
              size="18"
            />
          </span>
        </b-link>
      </template>
    </b-table>
  </b-overlay>
</template>

<script>
import ApiRestService from '@/api/base-api'

export default {
  name: 'ProvisionCategoriesTable',
  data () {
    return {
      loading: false,
      categories: [],
      fields: [
      {
          label: 'Nombre',
          key: 'name',
          sortable: false,
        },
        {
          label: '',
          key: 'actions',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
    }
  },
  methods: {
    async loadCategories () {
      this.loading = true
      try {
        const response = await ApiRestService.list({}, this.$data.$constants.RESOURCES.RESOURCE_PROVISION_CATEGORIES)
        this.categories = response.data
      } finally {
        this.loading = false
      }
    },
    async handleUpdate(category) {
      this.loading = true
      try {
        await ApiRestService.edit(category.id, category, this.$data.$constants.RESOURCES.RESOURCE_PROVISION_CATEGORIES)
      } finally {
        this.loading = false
      }
    },
    async handleDeleteButtonClick (category) {
      const response = await this.$modal.show({
        title: '¿Está seguro?',
        text: 'Se borrará el registro',
      })

      if (!response.isConfirmed) {
        return
      }

      this.loading = true
      try {
        await ApiRestService.delete(category.id, this.$data.$constants.RESOURCES.RESOURCE_PROVISION_CATEGORIES)
        await this.loadCategories()
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.loadCategories()
  },
}
</script>